<template>
  <div class="skin">
    <div class="skin-list">
      <template>
        <div
          v-for="(key, index) in list"
          class="item"
          :key="key + dataSource[key].icon.value"
          @click="handleSwitch(key)"

        >
          <div class="skin-btn" :class="{ active: key === current.key }" :title="dataSource[key].name.value">
            <img class="icon" alt="" :src="dataSource[key].icon.value" />
            <div class="tag" v-if="dataSource[key].tag.hasValue && dataSource[key].tag.value">
              {{ dataSource[key].tag.value }}
            </div>
          </div>
          <!-- 查看测评 -->
          <div class="go-btn" :class="{ active: key === current.key }" v-if="current.evaluation.link.value">
            <a :href="current.evaluation.link.value" target="_blank">
              <img src="@/assets/zs_imgs/skin-go-btn.png" alt="" />
            </a>
          </div>
        </div>
      </template>
    </div>
    <div class="skin-name">
      {{ current.name.value }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    current: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    list() {
      return Object.keys(this.dataSource).filter(key => {
        return this.dataSource[key].icon.hasValue;
      });
    }
  },
  methods: {
    handleSwitch(key) {
      this.$emit("switch", key);
    }
  }
};
</script>

<style lang="less" scoped>
.skin {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .skin-list {
    position: absolute;
    right: 787px;
    width: 148px;
    bottom: 50px;
    height: 240px;
    // display: flex;
    // flex-direction: column;
    // gap: 45px;
    // align-items: center;
    // justify-content: flex-end;
    padding: 10px 0 10px 23px;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .item {
      flex-shrink: 0;
      position: relative;

      width: 48px;
      height: 48px;
      margin-bottom: 38px;
      &:last-child {
        margin-bottom: 0;
      }

      .skin-btn {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 100%;
        background: #2f3a4a;
        border-radius: 50%;
        cursor: pointer;
        &.active {
          background: url('~@/assets/zs_imgs/skin-active-bg.png') no-repeat;
          background-size: 100% 100%;
        }
        .icon {
          position: absolute;
          left: -20%;
          top: -15%;
          width: 140%;
          height: 140%;
        }
        .tag {
          position: absolute;
          top: 4px;
          left: -23px;
          width: 36px;
          height: 18px;
          background: #0088d9;
          border-radius: 9px;
          border: 1px solid #ffffff;
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          line-height: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .go-btn {
        position: absolute;
        top: 9px;
        left: 7px;
        z-index: 1;
        width: 0;
        opacity: 0;
        overflow: hidden;
        height: 32px;
        background: rgba(126, 202, 255, 0.15);
        border-radius: 16px;
        padding: 6px 8px;
        transition: all 0.3s;
        &.active {
          width: 82px;
          opacity: 1;
        }
        img {
          float: right;
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .skin-name {
    position: absolute;
    z-index: 2;
    left: 50%;
    bottom: 27px;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 443px;
    height: 59px;
    background: url("~@/assets/zs_imgs/skin-name-bg.png") no-repeat;
    background-size: 100% 100%;
    font-family: 思源宋体;
    font-weight: 800;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>
